import b_ from 'b_';
import React from 'react';
import { WidgetConfigurationProps } from 'controls/designer/features/widgets/widgetConfig';
import { Section } from 'controls/react/layout/section';
import { i18n } from './localization';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput } from 'controls/react/ant/antInput';
import { observer } from 'mobx-react';
import { GlobalTimePeriodConfig } from 'controls/designer/features/widgets/globalTimeSelector/types';
import { AllowedPeriods, GlobalTimeSelectorStore } from 'controls/designer/features/widgets/globalTimeSelector/store';
import { TimePeriodAppearance, TimePeriodSelector } from 'controls/react/form/timePeriodSelector';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { AntSwitch } from 'controls/react/ant/antSwitch';
import { Toolbar } from 'controls/react/layout/toolbar';
import { GlobalTimePeriodWidgetType } from 'controls/designer/features/widgets/globalTimeSelector/index';
import { BoxView } from 'controls/react/layout/boxView';
import { fromStringsArray } from 'controls/react/ant/ant-select/utils/fromStringsArray';

const b = b_.with('global-time-selector-configuration');

class Configuration extends React.Component<WidgetConfigurationProps<GlobalTimePeriodConfig>> {
	store: GlobalTimeSelectorStore;

	constructor(props: WidgetConfigurationProps<GlobalTimePeriodConfig>) {
		super(props);
		this.store = new GlobalTimeSelectorStore({
			config: props.config,
			setValidator: props.setValidator,
			disableCreation:
				props.designerStore.customData.some((x) => x.widgetConfig?.type == GlobalTimePeriodWidgetType) &&
				this.props.mode == 'create',
		});
	}

	componentWillUnmount() {
		this.store.destroy();
	}

	render() {
		return (
			<Section containerClass={b()}>
				{this.store.widgetExists && <BoxView type={'info-2'}>{i18n('Widget already exists on dashboard')}</BoxView>}
				<Section
					title={i18n('General')}
					appearance={'frame-top-only'}
					contentPadding={true}
					childrenPadding={true}
					disabled={this.store.widgetExists}
				>
					<FormEntryNew label={i18n('Name')} model={this.store.model} modelField={'title'}>
						<AntInput />
					</FormEntryNew>
				</Section>
				<Section
					title={i18n('Time period')}
					appearance={'frame-top-only'}
					contentPadding={true}
					childrenPadding={true}
					disabled={this.store.widgetExists}
				>
					<Toolbar>
						<FormEntryNew label={''} model={this.store.model} modelField={'periodEnabled'}>
							<AntSwitch size={'small'} disabled={this.store.widgetExists} />
						</FormEntryNew>
					</Toolbar>
					{this.store.model.periodEnabled && (
						<FormEntryNew label={i18n('Time period')} model={this.store.model} modelField={'period'}>
							<TimePeriodSelector periods={AllowedPeriods} appearance={TimePeriodAppearance.Buttons} />
						</FormEntryNew>
					)}
				</Section>
				<Section
					title={i18n('Time zone')}
					appearance={'frame-top-only'}
					contentPadding={true}
					childrenPadding={true}
					disabled={this.store.widgetExists}
				>
					<Toolbar>
						<FormEntryNew label={''} model={this.store.model} modelField={'timeZoneEnabled'}>
							<AntSwitch size={'small'} disabled={this.store.widgetExists} />
						</FormEntryNew>
					</Toolbar>
					{this.store.model.timeZoneEnabled && (
						<FormEntryNew label={i18n('Time zone')} model={this.store.model} modelField={'timezone'}>
							<AntSelect
								options={fromStringsArray(this.store.timezones?.data)}
								loading={this.store.timezones?.loading}
							/>
						</FormEntryNew>
					)}
				</Section>
			</Section>
		);
	}
}

export default observer(Configuration);
